import type { ChartPoint } from '../ColumnChart/chart-point.ts';

export type ChartSeries = {
  readonly key: string;
  readonly label: string;
  readonly points: readonly ChartPoint[];
};

type SeriesMark = 'line' | 'dash' | 'rect';

export type SeriesKey = {
  readonly key: string;
  readonly label: string;
  readonly color: string;
  readonly mark: SeriesMark;
};

export const bucketsOf = (series: readonly ChartSeries[]): readonly ChartPoint[] => series[0]?.points ?? [];

export const valuesOf = (series: readonly ChartSeries[]): readonly number[] =>
  series.flatMap((entry) =>
    entry.points.filter((point) => point.missing !== true).map((point) => point.value),
  );

export const hasValues = (series: readonly ChartSeries[]): boolean =>
  series.some((entry) => entry.points.some((point) => point.missing !== true && point.value !== 0));
